import type { ComponentProps } from 'react';

const Cross = (props: ComponentProps<'svg'>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M36 12L12 36"
      stroke={props?.fill ?? '#8C98AB'}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 12L36 36"
      stroke={props?.fill ?? '#8C98AB'}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Cross;
